import { DateTime } from "luxon";
import { plusBusinessDay } from "./plusBusinessDay";

const SETTLEMENT_DATE_BUSINESS_DAYS_OFFSET = 2;

export const calculateSettlementDate = (date: DateTime, timezone: string) =>
  plusBusinessDay(date, timezone, SETTLEMENT_DATE_BUSINESS_DAYS_OFFSET);
